import { useQuery } from "react-query";

import type { GetUnsignedNotesArgs } from "api/services/admin/schemas/unsigned_notes";
import { useApiClient } from "api/useApiClient";

const getUnsignedNotesQueryKey = (args: GetUnsignedNotesArgs) =>
  ["getUnsignedNotes", args.health_care_organization_id, args.params] as const;

export const useGetUnsignedNotes = (args: GetUnsignedNotesArgs) => {
  const client = useApiClient();

  return useQuery(getUnsignedNotesQueryKey(args), () => client.getUnsignedNotes(args), { keepPreviousData: true });
};
